import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import ErrorPage from '..';

const Component404 = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const countdownTime = 5;
  const [time, setTime] = useState(countdownTime);
  const router = useRouter();

  const handleClick = () => {
    router.push('/');
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime((prev: number) => {
        if (prev <= 1) {
          clearInterval(intervalId);
          handleClick();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [router]);

  return (
    <ErrorPage
      title={
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { md: 48, xs: 36 },
            lineHeight: { md: '72px', xs: '43px' },
          }}
          textAlign="center"
          color={theme.palette.textV2.primary}
        >
          {t('error.404.title')}
        </Typography>
      }
      subtitle={
        <Typography variant="h4" textAlign="center" color={theme.palette.textV2.secondary}>
          {t('error.404.subtitle')}
        </Typography>
      }
      errorCode={
        <Typography variant="subtitle1" textAlign="center" color={theme.palette.textV2.secondary}>
          {t('error.404.errorCode')}
        </Typography>
      }
      extra={
        <Box
          sx={{
            margin: 3,
            padding: '10px',
            width: '80px',
            height: '80px',
            borderRadius: '100%',
            backgroundColor: theme.palette.grey.A100,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              padding: '10px 24px 10px 24px',
              width: '64px',
              height: '64px',
              borderRadius: '100%',
              backgroundColor: theme.palette.common.white,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: `0px 3px 6px 1px ${theme.palette}`,
            }}
          >
            <Typography variant="h1" color={theme.palette.textV2.disabled}>
              {time}
            </Typography>
          </Box>
        </Box>
      }
      buttonTitle={t('error.404.button.title')}
      buttonAction={handleClick}
      backgroundImageUrl="/static/images/common/bg-404-not-found.png"
    />
  );
};

export default Component404;
